module.exports = __webpack_public_path__ + "static/img/mnlogo.f2cf81a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/home/mnlogo.png
// module id = CD9G
// module chunks = 12